import { Card, Typography, Form, Input, Button, Switch, Divider } from 'antd'
import { SaveOutlined } from '@ant-design/icons'

const { Title, Paragraph, Text } = Typography

export function SettingsPage() {
  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <Title level={2} style={{ marginBottom: 8 }}>
          Settings
        </Title>
        <Paragraph type="secondary" style={{ marginBottom: 0 }}>
          Manage your account and application preferences
        </Paragraph>
      </div>

      <Card title="Account Settings" style={{ marginBottom: 16 }}>
        <Form layout="vertical">
          <Form.Item label="Full Name" name="name">
            <Input placeholder="Ricardo" size="large" />
          </Form.Item>
          <Form.Item label="Email" name="email">
            <Input placeholder="ricardo@example.com" size="large" disabled />
          </Form.Item>
          <Form.Item>
            <Button type="primary" icon={<SaveOutlined />} size="large">
              Save Changes
            </Button>
          </Form.Item>
        </Form>
      </Card>

      <Card title="Notification Preferences">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <Text strong>Email Notifications</Text>
              <br />
              <Text type="secondary" style={{ fontSize: 12 }}>
                Receive email updates about assessment completions
              </Text>
            </div>
            <Switch defaultChecked />
          </div>
          <Divider style={{ margin: 0 }} />
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <Text strong>Weekly Summary</Text>
              <br />
              <Text type="secondary" style={{ fontSize: 12 }}>
                Get weekly summaries of assessment activity
              </Text>
            </div>
            <Switch defaultChecked />
          </div>
          <Divider style={{ margin: 0 }} />
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <Text strong>Expiring Assessments</Text>
              <br />
              <Text type="secondary" style={{ fontSize: 12 }}>
                Alert me when assessments are about to expire
              </Text>
            </div>
            <Switch defaultChecked />
          </div>
        </div>
      </Card>
    </div>
  )
}

